<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FeSh2l/tc-custom/9781250036063.jpg?1731883537506" alt="This image is the cover for the book It's. Nice. Outside."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's. Nice. Outside.
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>It's. Nice. Outside. </i>explores that universal tension between being a parent and keeping true to yourself. </b><b>In this laugh-out-loud, heartbreaking, generous family novel, Jim Kokoris returns to the heartfelt writing of <i>The Rich Part of Life. </i></b><br/><br/>Meet John Nichols. He's 50-something years old, an ex-basketball player, ex-author, ex-philanderer, ex-husband, ex-high school English teacher. And he's father to three: two overachieving adult daughters, and 19 year-old Ethan, who will never be an adult. John's oldest daughter is getting married, and as the whole family travels from their homes in New York and the Chicago area, John is secretly preparing for a life-change that will alter his family's hearts forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Kokoris
      </h2>
      
      <p class="authorDescription body article"><P>JIM KOKORIS's work has appeared in the <I>Chicago</I><I> Tribune Sunday Magazine, USA Weekend, Chicago Sun-Times</I>, and <I>Reader's Digest</I>. He is the author of the novels <I>The Rich Part of Life</I>, which has been published in fifteen languages and for which he won a Friends of American Writers Award for Best First Novel, and the critically acclaimed <I>Sister North</I>. A graduate of the University of Illinois, Jim lives in the Chicago area.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32d12f1c